import { jsx } from 'panel';
import { SelectEl } from 'common/components/select';
import { CalendarEl } from 'common/components/calendar';
import { ButtonBarEl } from 'common/components/button-bar';
import { TooltipEl } from 'common/components/tooltip';
import { DisplayType, Placement } from 'common/components/tooltip/types';
import { ButtonEl } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
export function template() {
  const {
    dateInputFocused,
    description,
    invalidDescription,
    saving,
    tmpDate
  } = this.state;
  return jsx("div", {
    sel: '.create-annotation-container'
  }, jsx("div", {
    sel: '.create-annotation-header'
  }, jsx("div", {
    sel: '.create-annotation-label'
  }, "Add Annotation")), jsx("div", {
    sel: '.create-annotation-date-input-row'
  }, jsx("div", {
    sel: '.create-annotation-date-container'
  }, jsx(SelectEl, {
    sel: '.create-annotation-date-select',
    attrs: {
      open: dateInputFocused,
      'selected-option': this.helpers.getFormattedTime("MMM D, YYYY")
    },
    on: {
      menuChange: this.helpers.handleDateSelectChange
    }
  }, jsx("div", {
    sel: '.create-annotation-date-popup-content',
    attrs: {
      slot: "body"
    }
  }, jsx(CalendarEl, {
    attrs: {
      'selected-date': this.helpers.getFormattedTime("YYYY-MM-DD", tmpDate)
    },
    on: {
      selectDate: this.helpers.handleDateSelected
    }
  })), jsx("div", {
    sel: '.create-annotation-date-popup-footer',
    attrs: {
      slot: "footer"
    }
  }, jsx(ButtonBarEl, {
    sel: '.mp-button-bar-primary',
    attrs: {
      slot: "footer"
    },
    on: {
      click: this.helpers.handleSelectDateButtonClicked
    }
  }, "Select date"))), jsx("div", {
    sel: '.create-annotation-at-label'
  }, "at")), jsx("div", {
    sel: '.create-annotation-time-container'
  }, jsx(SelectEl, {
    sel: '.create-annotation-time-select',
    attrs: {
      'disable-search': true,
      sections: JSON.stringify([{
        items: this.helpers.getTimeItems()
      }]),
      'selected-option': this.helpers.getFormattedTime("hh:mma")
    },
    on: {
      change: this.helpers.handleTimeSelectChange
    }
  }))), jsx("div", {
    sel: '.create-annotation-description'
  }, jsx("textarea", {
    attrs: {
      placeholder: "Add a description"
    },
    on: {
      input: this.helpers.updateDescription
    },
    hook: {
      insert: this.helpers.descriptionTextareaInserted
    }
  }, description), invalidDescription ? jsx(TooltipEl, {
    attrs: {
      'always-show': true,
      placement: Placement.Bottom,
      type: DisplayType.Error
    }
  }, "Please enter a description") : null), jsx("div", {
    sel: '.create-annotation-actions-row'
  }, jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Tertiary
    },
    on: {
      click: this.helpers.cancelCreation
    }
  }, "Cancel"), jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Primary,
      disabled: saving
    },
    on: {
      click: this.helpers.saveAnnotation
    }
  }, "Save")));
}